import '../../../../vendor/assets/javascripts/jquery.inputmask';

// Legacy jQuery ./components w/ on ready hooks
import * as CheckoutTotals from './bundled_checkout/checkout_totals';
import './products_show';
import './products_view';
import './reverb.attachinary';
import './attachinary_fields';
import './legacy/detector/trade';
import './legacy/shop_policies';
import './dashboard/index';
import './legacy/mobile_web_image_zoom';
import './legacy/plugins/jquery.check-all';
import './legacy/plugins/jquery.click-off-close';
import './legacy/plugins/jquery.price-mask';
import './legacy/plugins/jquery.spin';
import './legacy/jquery.onanimate';
import './legacy/jquery.focusFirstInput';
import './legacy/jquery.simple-method';
import './legacy/address';
import './legacy/animations';
import Tabs from './legacy/nav-tabs';
import './legacy/image-gallery';
import './legacy/badges';
import './legacy/user_activity';
import './legacy/paypal_profile';
import './legacy/autosubmit';
import './legacy/remote_tooltip';
import './legacy/remote_checkbox';
import './legacy/character_limit';
import './legacy/numbers';
import './legacy/tax_forms';
import './legacy/cart';
import './legacy/ajax_pagination';
import './legacy/block_seller_action';
import './legacy/order_totaler';
import './legacy/s3_uploader';
import './legacy/video';
import './legacy/responsive-menu';
import './legacy/open_lightbox_on_load';
import './legacy/raty';
import './dashboard/selling/bump/remote_reservations';

// bundled checkout (TODO: still used?)
import './legacy/bundled_checkout/toggle_form';
import './legacy/bundled_checkout/credit_card';
import './legacy/bundled_checkout/discount_codes';

// dashboard
import './legacy/dashboard/feedback';

import './legacy/dashboard/messages';
import './legacy/dashboard/messages/toggle_read_status';
import './legacy/dashboard/refund_request_adjustment';
import './legacy/dashboard/selling/billing';
import './legacy/dashboard/selling/bulk_bump';
import './legacy/dashboard/selling/delete_draft';
import './legacy/dashboard/selling/refund_requests';
import './legacy/dashboard/selling/seller_sales';
import './legacy/dashboard/selling/shipping_labels';
import './legacy/dashboard/shop';
import './legacy/dashboard/submit_offer_lightbox';

// offers
import './legacy/offers/inline_offer';

// listing
import './legacy/listing/general';

import './legacy/listing/inventory';
import './legacy/listing/shipping_validation';
import './legacy/listing/add_shipping_rate';
import './legacy/listing/payment_method_validation';
import './legacy/listing/caps_detector';
import './legacy/listing/product_type_change';

// shipping
import './legacy/shipping/estimator';

import './legacy/shipping/shipping_profile_select';

// init
import './legacy/init/chosen';

import './legacy/init/datepicker';
import './legacy/init/autocomplete';
import './legacy/init/ajax_safety';
import './legacy/init/temporal';

// dom
import './legacy/dom/dom-patterns';

import './legacy/dom/remove';
import './legacy/dom/remove-parent';
import './legacy/dom/disclosure-toggle';
import './legacy/dom/smooth_scrolling';
import './legacy/dom/store-checkbox';
import './legacy/dom/delay-submit';
import './legacy/highlight';
import './legacy/html5_validation';
import './legacy/link_to_back';
import './legacy/ajax_load_and_replace';
import './legacy/ajax_fetch_on_page_load';

// mobile
import './legacy/mobile/tooltips';

import './legacy/mobile/menu';

// image_attachment
import './legacy/better_dragdrop';

import AdminBump from './legacy/admin/bump';

// auctions
import AuctionBidAmountChecker from './legacy/auctions/bid_amount_checker';

import AuctionBidPlacement from './legacy/auctions/bid_placement';
import AuctionCountdown from './legacy/auctions/countdown';
import AuctionCreate from './legacy/auctions/create';

import BidResponseHandler from './legacy/auctions/bid_response_handler';

import BumpShopStats from './legacy/bump/shop_stats';
import FeedbackTips from './legacy/feedback_tips';
import GiftCardRedeem from './legacy/gift_cards/redeem';
import GiftCardAccountForm from './legacy/gift_cards/create_account_form';
import WishList from './legacy/wish_list';
import NagAlerts from './legacy/nag_alerts';
import NewsletterSamples from './legacy/newsletter_samples';
import Panels from './legacy/panels';
import SalesManagement from './legacy/sellers/sales_management';


import Messages from './legacy/messages';
import ReverbOffers from './legacy/reverb_offers';
import ShippingLabelRatesForm from './legacy/shipping_labels/rates_form';

window.Tabs = Tabs;
window.Reverb = { ...window.Reverb, Auctions: { BidResponseHandler } };
window.Reverb.BundledCheckout = {
  ...window.Reverb.BundledCheckout,
  rerenderTotals: CheckoutTotals.rerenderTotals,
};

$(() => {
  AuctionBidAmountChecker.init();
  AuctionBidPlacement.init();
  AuctionCountdown.init();
  AuctionCreate.init();
  BumpShopStats.init();
  AdminBump.init();
  GiftCardRedeem.init();
  GiftCardAccountForm.init();
  WishList.init();
  NagAlerts.init();
  Panels.init();
  SalesManagement.init();
  FeedbackTips.init();
  NewsletterSamples.init();
  Messages.init();
  ReverbOffers.init();
  ShippingLabelRatesForm.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy.js